import { HEADERS, simpleFetch } from './customFetch';
import { ZERO_UUID } from './uncurl';

export const getCartsTimers = (membershipTier?: string) =>
  simpleFetch(
    'api/1/carts/timers' + (membershipTier ? `?membershipTier=${membershipTier}` : ''),
    {},
    process.env.REACT_APP_ACE_API,
  );

/**
 * Create a single-item INSTANT cart holding the subscription product being upgraded TO, for the
 * Cart 2.0 / UnCurl upgrade path. Returns the parsed ace-api response; the created cart's uuid is at
 * `data.items[0].uuid`. `accept: application/vnd.fabfitfun.v2+json` selects the v2 cart response.
 */
export const createInstantSubscriptionCart = (productUuid: string) =>
  simpleFetch(
    'api/1/carts/',
    {
      method: 'POST',
      body: JSON.stringify({
        sourceType: 'INSTANT',
        cartItems: [
          {
            productUuid,
            catalogUuid: ZERO_UUID,
            saleUuid: ZERO_UUID,
            quantity: 1,
            cartItemPreferences: { SUBSCRIPTION_CADENCE: 'SCHEDULED' },
          },
        ],
      }),
      headers: { ...HEADERS, accept: 'application/vnd.fabfitfun.v2+json;charset=UTF-8' },
    },
    process.env.REACT_APP_ACE_API,
  );
